const my_profile = {
  viewMyClubSeacretProfile: "ดูโปรไฟล์ ClubSeacret ของฉัน", // translated
  viewMoreDetails: "ดูรายละเอียดเพิ่มเติม", // translated
  verifiedEmail: "อีเมลที่ยืนยันแล้ว", // translated
  unverifiedEmail: "อีเมลที่ไม่ได้รับการยืนยัน", // translated
  pointsIn: "ชี้เข้า", // translated
  pointsOut: "ชี้ให้เห็น", // translated
  balance: "สมดุล", // translated
  pointsHistoryTable: "ตารางประวัติคะแนน", // translated
  topUp: "เติม", // translated
};

export default my_profile;
